module.exports = __webpack_public_path__ + "img/thumbnail.4cd1f5ac.jpg";